var render = function render(){var _vm=this,_c=_vm._self._c;return _c('defs',_vm._l((_vm.connections),function(conn){return _c('ConnectionMarker',{key:`${conn.id}-connection-marker`,attrs:{"conn":conn,"type":conn.markerEnd}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }